<template>
<div class="meter-house-customer">
  <div class="meter-house-customer-header">
    <el-button type="primary" @click="getList()" size="mini">查询</el-button>
    <el-button type="primary" @click="updateNowHouseCustomer()" size="mini">更新业主</el-button>

    <slot />
  </div>
  <div class="meter-house-customer-search">
    <el-descriptions label-width="100px" :column="2" border>
      <el-descriptions-item label="项目名称">
        {{mainObj.project_name}}
      </el-descriptions-item>
      <el-descriptions-item label="房产名称">
        {{mainObj.house_name}}
      </el-descriptions-item>
    </el-descriptions>
  </div>
  <div>
    <div class="header-tip">
      移动业主数量：{{pageData.total}}
    </div>
  </div>
  <div class="meter-house-customer-body">
    <el-table
      :data="pageData.data"
      :border="true"
      style="width: 100%" height="50vh">
      <el-table-column type="selection" width="55" fixed></el-table-column>
      <el-table-column prop="房产" label="房产" width="320" fixed></el-table-column>
      <el-table-column prop="当前业主ID" label="当前业主ID" width="90"></el-table-column>
      <el-table-column prop="当前业主" label="当前业主" width="120"></el-table-column>
      <el-table-column prop="最新业主ID" label="最新业主ID" width="90"></el-table-column>
      <el-table-column prop="最新业主" label="最新业主" width="120"></el-table-column>
      <el-table-column prop="count" label="仪表数量" width="90"></el-table-column>
      <el-table-column prop="仪表编号" label="仪表编号" width="120">
        <template slot-scope="scope">
          <el-popover
            placement="bottom"
            width="400"
            trigger="click"
            :content="scope.row['仪表编号']">
            <el-button size="mini" slot="reference">详情</el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="仪表名称" label="仪表名称" width="120">
        <template slot-scope="scope">
          <el-popover
            placement="bottom"
            width="400"
            trigger="click"
            :content="scope.row['仪表名称']">
            <el-button size="mini" slot="reference">详情</el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" @click="updateNowHouseCustomer(scope.row.erp_house_id)" size="mini">更新业主</el-button>
<!--          <el-button type="text" @click="handleDelete(scope.$index)">删除</el-button>-->
        </template>
      </el-table-column>

    </el-table>
    <div class="meter-house-customer-pagination">
      <el-pagination
        layout="prev, pager, next"
        :total="pageData.total"
        :current-page="pageData.current_page"
        :page-size="pageData.per_page"
        @current-change="pageChange"
      >
      </el-pagination>
    </div>
  </div>
</div>
</template>

<script>
import MeterHttp from "../../common/MeterHttp";

export default {
  name: "MeterHouseCustomer",
  inject:['mainObj','componentId','setComponentId'],
  data() {
    return {
      pageData: {
        total: 0,
        per_page: 20,
        current_page: 1,
        last_page: 1,
        data: [],
      },
      multipleSelection: [],
      loading:false,
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getList(){
      const that=this;
      if(!that.project_id){
        return;
      }
      that.loading=true;
      that.multipleSelection=[];
      MeterHttp.post(`MeterCustomer/getHouseCustomerList?user_type=${that.$route.query.type}&page=${that.pageData.current_page}`,{
        project_id: that.project_id,
        house_id:that.mainObj.house_id,
      },res=>{
        that.loading=false;
        if(res.code){
          that.pageData=Object.assign({
            total: 0,
            per_page: 20,
            current_page: 1,
            last_page: 1,
            data: [],
          },res.data);
        }
      })
    },
    pageChange(page=1){
      const that=this;
      console.log(page);
      that.pageData.current_page=page;
      that.getList();
    },
    updateNowHouseCustomer(house_id=0){
      const that=this;
      if(!that.project_id){
        return;
      }
      let house_ids=[];
      let msg="";
      if(house_id){
        house_ids=[house_id];
        msg=`更新房产业主`;
      }else {
        if(that.multipleSelection.length>0){
          house_ids=that.multipleSelection.map(item=>item.erp_house_id).filter(item=>item);
          msg=`将要更新${that.multipleSelection.length}个房产业主`;
        }
      }

      that.$confirm(msg, '更换业主提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.loading=true;
        that.multipleSelection=[];
        MeterHttp.post(`MeterCustomer/updateNowHouseCustomer?user_type=${that.$route.query.type}`,{
          project_id: that.project_id,
          house_ids:house_ids.join(','),
        },res=>{
          that.loading=false;
          if(res.code){
            that.getList();
          }else {
            that.$message.error(res.msg||'调整异常');
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
  },
  mounted() {
    const that=this;
    that.pageChange();
  },
  computed:{
    project_id(){
      return this.mainObj.project_id
    }
  },
  watch:{
    project_id(n,o){
      const that=this;
      if(n){
        // setTimeout(()=>{
        //   that.reGetDate()
        // },500);
        that.pageChange();
      }
    },
    "mainObj.house_id":function(n,o){
      const that=this;
      if(n){
        that.pageChange();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
.meter-house-customer{
  .meter-house-customer-header{
    display: flex;
    //justify-content: space-between;
    align-items: center;
  }
 .meter-house-customer-body{
    padding: 10px 0;
  }
 .meter-house-customer-pagination{
    padding: 10px;
    text-align: center;
 }
  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/MeterHouseCustomer.vue